export const technicalSpecificationFields = graphql`
  fragment technicalSpecificationFields on ContentfulSpecComponent {
    additionalInformation
    cageDimensions
    capacity
    closedHeight
    decibelLevel
    depth
    diameter
    dimensions
    leadColourAndSize
    lengthStowed
    liftingCapacity
    height
    horizontalOutreach
    length
    liftHeight
    motor
    pipeCapacity
    platformHeight
    power
    powerFactor
    powerSupply
    reachHeight
    rollOutDeckExt
    size
    suitableFor
    swl
    vibrationLevel
    voltage
    weight
    weightAllowed
    width
    widthFullyJacked
    widthOneSideJacked
    widthWorking
  }
`



// WEBPACK FOOTER //
// ./src/containers/Product/Query.js